import { useContext } from 'react';
import { TableContext } from '../../Table.context';
import TableActions from '../TableActions/TableActions';
import TableCell from '../TableCell/TableCell';
import { Wrapper } from './TableRow.style';

export type TableRowProps = {
  rowData: IModel;
};

export function TableRow(props: TableRowProps) {
  const { rowData } = props;
  const { config, patchState, state } = useContext(TableContext);

  const isHovered = state.hoverId === rowData.id;

  function onMouseOver() {
    patchState({ hoverId: rowData.id });
  }

  function onMouseOut() {
    patchState({ hoverId: '' });
  }

  const { fields } = config;

  function renderCell(cell: ITableField) {
    return <TableCell key={cell.id} field={cell} rowData={rowData} />;
  }

  function renderCells() {
    return fields.map((cell: ITableField) => renderCell(cell));
  }

  return (
    <Wrapper
      className='TableRow-wrapper'
      data-testid='TableRow-wrapper'
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {renderCells()}
      <TableActions itemId={rowData.id} show={isHovered} />
    </Wrapper>
  );
}

export default TableRow;
